// Main Frame exports
export { createViteConfig } from './config/ViteConfig';
export { ConfigLoader } from './config/ConfigLoader';
export type { FrameConfig } from './config/ConfigLoader';

// Plugin exports
export { createRouterPlugin } from './plugins/RouterPlugin';
export { createEntryPlugin } from './plugins/EntryPlugin';
export { createAssetPlugin } from './plugins/AssetPlugin';
export { createTypeScriptPlugin } from './plugins/TypeScriptPlugin';

// Command exports
export { DevCommand } from './commands/DevCommand';
export { BuildCommand } from './commands/BuildCommand';
export { PreviewCommand } from './commands/PreviewCommand';
export { InitCommand } from './commands/InitCommand';
export type { InitOptions } from './commands/InitCommand';
export type { DevOptions } from './commands/DevCommand';

// Build system exports
export { BuildManager } from './build/BuildManager';
export type { BuildOptions } from './build/BuildManager';
export { BaseAdapter } from './adapters/BaseAdapter';
export type { BuildContext, DeploymentTarget, AdapterOptions } from './adapters/BaseAdapter';
export { StaticAdapter } from './adapters/StaticAdapter';

// Utility exports
export { BaseCommand } from './commands/BaseCommand';

// Import functions for default export
import { createViteConfig } from './config/ViteConfig.js';
import { createRouterPlugin } from './plugins/RouterPlugin.js';
import { createEntryPlugin } from './plugins/EntryPlugin.js';

// Default export with main utilities
export default {
    createViteConfig,
    createRouterPlugin,
    createEntryPlugin,
};


